import React from 'react';
import classNames from 'classnames';

import { User } from '../types';

import styles from './UserAvatar.module.css';

export function UserAvatar({ user }: { user: User }) {
  const { avatarUrl } = user;
  const isShowingInitials = !avatarUrl;

  let avatarFragment;
  if (isShowingInitials) {
    const initials = getInitials(user);

    avatarFragment = <span className={classNames(styles.avatar, styles.avatarInitials)}>{initials}</span>;
  } else {
    avatarFragment = <img className={styles.avatar} src={avatarUrl} alt={`${user.displayName}'s avatar`} />;
  }

  return (
    <div
      className={classNames({
        [styles.avatarContainer]: true,
        [styles.showingInitials]: isShowingInitials,
      })}
    >
      {avatarFragment}
    </div>
  );
}

function getInitials(user: User) {
  let initialsParts = [user.firstName, user.lastName].filter(Boolean);

  if (initialsParts.length === 0 && user.displayName) {
    initialsParts = user.displayName.split(' ');
  }

  initialsParts = initialsParts.slice(0, 2);

  const initials = initialsParts
    .filter(Boolean)
    .map(s => s && s[0])
    .join('')
    .toUpperCase();
  if (!initials) return null;

  return initials;
}

export default UserAvatar;
